import { onBeforeUnmount, onMounted } from "vue";

export const useResizeAdjuster = () => {
  const resizeHandler = () => {
    const main = document.querySelector("main");
    if (main) {
      main.style.height = `${window.innerHeight}px`;
    }
  };

  onMounted(() => {
    resizeHandler();
    setTimeout(() => {
      resizeHandler();
    }, 1000);
    window.addEventListener("resize", resizeHandler);
  });

  onBeforeUnmount(() => {
    window.removeEventListener("resize", resizeHandler);
  });
};
